import { BsX, BsPlus } from "react-icons/bs"
import React from "react"
import Zahlungsbedingung from "../../../models/zahlungsbedingung"

export interface ZahlungsbedingungViewProps {
    idx: number
    zahlungsbedingung: Zahlungsbedingung
    onRemove?: () => void
    onAdd?: () => void
    onChange: (propertyName: string) => (value: unknown) => void
}

export const ZahlungsbedingungEinfachEintragView: ({
    idx,
    zahlungsbedingung,
    onRemove,
    onChange,
    onAdd,
}: ZahlungsbedingungViewProps) => React.JSX.Element | null = ({ idx, zahlungsbedingung, onRemove, onChange, onAdd }) => {
    return (
        <React.Fragment key={idx}>
            <div className="input-group mb-3">
                <input
                    type="text"
                    className="form-control"
                    onChange={(event) => onChange("zahlungszeile").call(this, event.target.value)}
                    value={zahlungsbedingung._zbEinfach ? zahlungsbedingung.zahlungszeile : zahlungsbedingung.beschreibungstext}
                    title={
                        "Eine Textbeschreibung der Zahlungsbedingungen, die für den fälligen Zahlungsbetrag gelten (einschließlich\n" +
                        "Beschreibung möglicher Skonto- und Verzugsbedingungen). Dieses Informationselement kann mehrere Zeilen" +
                        " beinhalten. Nur unstrukturierter Text wird unterstützt."
                    }
                />
                <div className="input-group-append">
                    {!!onRemove && (
                        <button className="btn btn-outline-secondary" type="button" onClick={onRemove} title="Löschen Sie diesen Text.">
                            <BsX size={20} />
                        </button>
                    )}
                    {!!onAdd && (
                        <button className="btn btn-outline-secondary" type="button" onClick={onAdd} title="Fügen Sie einen weiteren Text hinzu.">
                            <BsPlus size={20} />
                        </button>
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}
